<template>
  <div class="company-info" :class="className">
    <div class="company-info-title" v-if="tag === 'list'">
            <span>
                {{title}}
            </span>

    </div>

    <div class="content-box">
      <div class="company-info-title" v-if="tag !== 'list'">
            <span style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis; ">
                {{title}}
            </span>
      </div>
      <div class="img-box">
        <img :src="imgUrl" class="preview-img">
      </div>

      <div class="product-info-box">
        <div>

          <div class="title-box" v-if="null != obj.productname">
            <span>{{obj.productname}}</span>
          </div>

          <div class="text-box" >

            <el-button plain type="primary" text @click="goSubtract" >-</el-button>
            <el-input style="width: 80px;" v-model="obj.qty" >{{obj.qty}}</el-input>

            <el-button plain type="primary" text @click="goAdd" >+</el-button>

            <el-text>    {{obj.unit}}</el-text>
          </div>
        </div>

        <div class="shop-info">
          <div>
            &nbsp;<span class="price-span">${{obj.curr}} {{obj.cost}}</span>
          </div>

          <div>
            <el-button plain type="danger" text @click="goDelete" >{{i18n.tkey('lang_delete')}}</el-button>
          </div>
        </div>
      </div>

    </div>


  </div>
</template>

<script setup>
import {computed, getCurrentInstance, inject} from 'vue'
import myUtil from "@/util/util";

const i18n = inject("i18n")
let { proxy } = getCurrentInstance();

const props = defineProps(["type","tag", 'obj', 'title', 'imgUrl','indexnum', 'btnLabel'])
const emits = defineEmits(['click-subtract-num','click-add-num','click-delete-shopchart'])


const className = computed(() => {
  let name = "company-info-block"

  if(null != props.tag && props.tag === "list"){
    name = "company-info-list"
  }

  return name
})

function goDelete() {
  emits("click-delete-shopchart", props.obj)
}

function goSubtract(){

  emits("click-subtract-num", props.indexnum)
}
function goAdd(){

  emits("click-add-num", props.indexnum)
}

</script>

<style scoped>
.company-info {
  border: 1px #DCDFE6 solid;
  line-height: 2;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 5px;
}

.company-info:nth-child(even) {
  background: #f9f9f9;
}

.company-info-title {
  text-align: left;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.company-info-block .shop-info {
  text-align: center;
  line-height: 1.5;
}

.company-info-list .shop-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.price-span {
  color: #e83f33;
  font-weight: 600;
}

.company-info-block .content-box {
//display: flex;
}

.company-info-list .content-box {
  display: flex;
}

.company-info-block .img-box {
  width: 100%;
  padding-top: 100%;
  position: relative;
}

.company-info-list .img-box {
  width: 80px;
  height: 80px;
}

.company-info-block .preview-img {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 1px #d6d6d6 solid;
  position: absolute;
  left: 0;
  top: 0;
}

.company-info-list .preview-img {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 1px #d6d6d6 solid;
}

.company-info-block .product-info-box {
//width: calc(100% - 80px);
  width: 100%;
  box-sizing: border-box;
  padding-left: 5px;
}

.company-info-list .product-info-box {
  width: calc(100% - 80px);
  box-sizing: border-box;
  padding-left: 5px;
}

.company-info-block .product-info-box .title-box {
  font-size: 14px;
  text-align: center;
  line-height: 2;
//padding-bottom: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
}

.company-info-list .product-info-box .title-box {
  font-size: 14px;
  text-align: left;
  line-height: 2;
  padding-bottom: 5px;
}

.product-info-box .text-box {
  font-size: 12px;
  text-align: left;
  line-height: 1.5;
  color: #666;
  min-height: 3em;
}
</style>